'use strict';

import Events from 'helpers/events';
import UserMenu from 'components/userMenu';
import Feature from 'helpers/feature';
import 'bundles/video/lockSlateTracking';
import { fireTrackingEvent, isNavMenuItem } from 'helpers/trackingOM';
import 'components/accessibilityGeneral';

/**
 * Header component class
 */
export default class Header {
    constructor() {
        this.authSuiteEnabled = false;

        if (CBS.Registry.authSuiteConfig && CBS.Registry.authSuiteConfig.enabled) {
            import(
                /* webpackChunkName: "auth-suite-sdk" */
                'services/AuthSuite/AuthSuiteSdkProvider'
            ).then((module) => {
                const AuthSuiteSdkProvider = module.default;

                const { clientId, countryCode, env } = CBS.Registry.authSuiteConfig;
                const authSuiteCountryCode = countryCode || CBS.Registry.region.property;

                this.authSuiteSdkProvider = new AuthSuiteSdkProvider({
                    clientId,
                    countryCode: authSuiteCountryCode,
                    env
                });
                this.authSuiteEnabled = true;

                this.checkAuthSuiteAuthStatus();
            });
        }

        /**
         * Marquee copy h1 element
         *
         * @type {Element | null}
         */
        this.marqueeCopy = document.querySelector('#hero-content .slide-js h1');

        /**
         * Headder element
         *
         * @type {*|jQuery|HTMLElement}
         */
        this.headerEl = $('header');
        this.heroImage = $('.hero_carousel_image');
        this.headerWrap = $('header .header__wrap');

        /**
         * Sub nav element
         *
         * @type {*|jQuery|HTMLElement}
         */
        this.subnavEl = $('#subnav');

        /**
         * Defines mobile dom elements
         *
         * @type {{icon: Element | null, menu: Element | null, subNavs: Header.mobile.subNavs}}
         */
        this.mobile = {
            icon: document.querySelector('header .burger'),
            menu: document.querySelector('#pv-dropdown'),
            subNavs: document.querySelectorAll('#pv-dropdown .withSubMenu'),
            skip: document.querySelector('#skip-link')
        };

        /**
         * initialize navigation header
         */
        this.initializeHeader();

        /**
         * initialize ie11 & Edge styles
         */
        this.initStylesForIE();

        /**
         * initialize mobile menu
         */
        this.initializeMobileMenu();

        /**
         * initialize logged in user menu
         */
        if (CBS.Registry.user_auth) {
            this.initializeUserMenu();
        }

        /**
         * keyboard navigation / tabbing bind
         */
        this.keyboardNav();

        this.initializeTracking();
    }

    /**
     * Keyboard navigation / Tabbing
     */
    keyboardNav() {
        $(document).on('keydown', function (event) {
            if (event.key === 'Escape') {
                /* hide any and all sub menu */
                $('ul.content').removeClass('filter-focus');
                /* turn control to mouse - this will remove all keyboard tab focus element */
            }
        });

        /* let css/js knows you are navigating using mouse,
        so remove any style set toward keyboard focus usage */
        $('body').mousedown(function () {
            /* Hide dropdown sub menu once user tab to the next item */
            $('li.header__nav--withsubMenu ul.content').removeClass('filter-focus');
        });

        /* hide the hamburger menu during keyboard tab activities */
        if ($(window).width() >= 1024) {
            $('.mobileMenu').find('a').attr('tabindex', '-1');
        }

        $(window).on('resize', function (event) {
            if ($(this).width() < 1024) {
                $('.mobileMenu').find('a').attr('tabindex', '0');
            } else {
                $('.mobileMenu').find('a').attr('tabindex', '-1');
            }
        });

        /* Hide the dropdown sub menu once user tab to the next item */
        $('ul.navigation li a').focus(function () {
            if (!$(this).parents(':eq(2)').hasClass('header__nav--withsubMenu')) {
                $('li.header__nav--withsubMenu ul.content').removeClass('filter-focus');
            }
        });

        /* Hide the sign in dropdown sub menu once user leave sub menu */
        $('ul.header__account li ul.content li').on('keydown', 'a', function (e) {
            const lastItem = $(this).parent('li').next('li').length;
            const keyCode = e.keyCode || e.which;

            if (!e.shiftKey && keyCode === 9) {
                // keyboard forward tab
                if (lastItem === 0) {
                    $(this).closest('ul.content').removeClass('filter-focus');
                }
            }
        });

        /* Hide dropdown sub menu once user tab to the next item */
        $('ul.subnav__items li a').focus(function () {
            $('li.header__nav--withsubMenu ul.content').removeClass('filter-focus');
        });

        /* dislpay the dropdown sub menu if menu has one */
        $('.header__nav--withsubMenu a.filter').focus(function () {
            $('li.header__nav--withsubMenu ul.content').removeClass('filter-focus');
            $(this).siblings().addClass('filter-focus');
        });

        /* dislpay the dropdown sub menu if menu has one and where menu has no label of its own */
        $('.header__nav--withsubMenu ul.content li a').focus(function () {
            if ($(this).parents(':eq(2)').hasClass('header__nav--withsubMenu')) {
                $('li.header__nav--withsubMenu ul.content').removeClass('filter-focus');
                $(this).parents(':eq(1)').addClass('filter-focus');
            }
        });
    }

    initializeTracking() {
        $('.header__wrap a').on('click', function (e) {
            let element = $(e.currentTarget)[0];
            
            fireTrackingEvent(element);
        });
        $('.mobileMenu a').on('click', function (e) {
            const element = $(e.currentTarget)[0];
            const elementHref = element.getAttribute('href');

            // Find the matching link in the desktop menu and pass that to be tracked
            // This ensures that the posRowNum and posColNum is consistent across devices
            const matchingLinkInDesktopMenu = $(`.header__wrap a[href="${elementHref}"]`);
            const desktopElement = matchingLinkInDesktopMenu[0];

            if (desktopElement) {
                fireTrackingEvent(desktopElement, true);
            } else {
                fireTrackingEvent(element, true);
            }
        });
    }

    /**
     * Detect scroll event and fire necessary callbacks
     */
    initializeHeader() {
        let last = 40,
            context = this;

        $(window).scroll(function (e) {
            if (context.headerEl.hasClass('mobileMenu--open')) {
                return;
            }

            let pos = $(this).scrollTop();

            if (pos > last) {
                context.onScrollDownHandler();
            } else {
                context.onScrollUpHandler();
            }

            last = pos;

            // schedule page locking subnav
            if ($('section .sc_cont').length) {
                var posi = $(this).scrollTop();
                if (posi <= 66) {
                    $('#addFilter').addClass('addPad');
                } else {
                    $('#addFilter').removeClass('addPad');
                }

                $('.date-item').each(function () {
                    var distance = $(this).offset().top.toFixed();
                    var itemPos = distance - $(window).scrollTop();

                    if (itemPos <= 0) {
                        $('.js-filter').first().text($(this).attr('data-value'));
                    }
                });
            }
            // end schedule page subnav
        });
    }

    /**
     * Initialize mobile menu and hook up event listeners
     *
     */
    initializeMobileMenu() {
        if (this.mobile.skip) {
            this.mobile.skip?.setAttribute('aria-hidden', 'true');
        }
        if (this.mobile.menu) {
            this.mobile.menu.setAttribute('aria-hidden', 'true');
        }
        let headerObj = document.querySelector('header');

        let mobileIcon = this.mobile.icon;

        if (mobileIcon) {
            mobileIcon.addEventListener(
                'click',
                () => {
                    mobileIcon.classList.toggle('is-active');

                    setTimeout(() => {
                        this.mobile.menu.classList.toggle('open');
                        headerObj.classList.toggle('mobileMenu--open');
                        this.subnavEl.toggleClass('hidden');
                    }, 300);

                    // if view port changes while menu is open
                    if (mobileIcon.classList.contains('is-active')) {
                        this.resetMenuIfViewPortChangeHandler();
                        mobileIcon.setAttribute('aria-label', 'Close Menu');
                        mobileIcon.setAttribute('aria-expanded', 'true');
                    } else {
                        mobileIcon.setAttribute('aria-label', 'Open Menu');
                        mobileIcon.setAttribute('aria-expanded', 'false');
                    }
                },
                Feature.supportsPassive() ? { passive: true } : false
            );
        }

        if (this.mobile.subNavs) {
            let s = this.mobile.subNavs;
            let len = s.length;

            for (let i = 0; i < len; i++) {
                let o = s[i];
                let f = o.querySelector('.filter');
                f.addEventListener(
                    'click',
                    () => {
                        o.classList.toggle('open');
                    },
                    Feature.supportsPassive() ? { passive: true } : false
                );
            }
        }
    }

    /**
     * Resets mobile menu if view port changed to desktop
     *
     */
    resetMenuIfViewPortChangeHandler() {
        let reset = false,
            timer;

        window.addEventListener('resize', (evt) => {
            clearTimeout(timer);

            timer = setTimeout(() => {
                if (reset === false) {
                    if ($(window).width() > 1024) {
                        this.resetMobileMenu();
                        reset = true;
                    }
                }
            }, 500);
        });
    }

    /**
     * Check users auth status
     * if user is MVPD_AUTHZ and authsuite authorization is null, then display noAuthN error.
     */
    async checkAuthSuiteAuthStatus() {
        if (CBS?.Registry?.user?.sb === 'MVPD_AUTHZ') {
            const { accessService } = this.authSuiteSdkProvider.getAuthSuiteServices();

            let isAuthorized;
            try {
                await accessService.checkAccessStatus();
                isAuthorized = await accessService.checkIsAuthorized('paramountplus');
            } catch (e) {
                isAuthorized = false;
            }

            if (!isAuthorized) {
                const { countryCode } = CBS.Registry.authSuiteConfig;

                import(
                    /* webpackChunkName: "api-service" */
                    'vue/services/ApiService'
                ).then((module) => {
                    const { deauthorize, unbindWithAuthSuite } = module;

                    deauthorize();
                    unbindWithAuthSuite();
                });

                window.location = `/${countryCode}/partner/?noAuth=true`;
            }
        }
    }

    initializeUserMenu() {
        let userMenu = new UserMenu();
        let logoutBtns = document.querySelectorAll('.js-user-logout');
        let authSuiteServices = {};
        let authSuiteEnabled = this.authSuiteEnabled;
        if (this.authSuiteEnabled) {
            authSuiteServices = this.authSuiteSdkProvider.getAuthSuiteServices();
        }

        logoutBtns.forEach((btn) => {
            btn.addEventListener('click', async function (e) {
                e.preventDefault();

                if (authSuiteEnabled) {
                    let accessStatus;
                    try {
                        accessStatus = await authSuiteServices.accessService.checkAccessStatus();
                        if (accessStatus && accessStatus.accessMethodsInUse.length > 0) {
                            userMenu.logoutWithAuthSuite(authSuiteServices.authorizationService);
                            return;
                        }
                    } catch (e) {
                        console.error(`Authsuite error: ${e}`);
                    }
                }
                userMenu.logout();
            });
        });
    }

    /**
     * Resets mobile menu
     * Close mobile menu programatically
     *
     */
    resetMobileMenu() {
        let headerObj = document.querySelector('header');

        this.mobile.icon.classList.remove('is-active');
        this.mobile.menu.classList.remove('open');
        headerObj.classList.remove('mobileMenu--open');
        this.subnavEl.removeClass('hidden');

        if (window.innerWidth > 1024) {
            this.mobile.menu.setAttribute('aria-hidden', 'true');
        } else {
            this.mobile.menu.removeAttribute('aria-hidden');
        }
    }

    /**
     * Event handler for scroll down event
     */
    onScrollDownHandler() {
        // safari bounce?
        let scrollTop = window.scrollY;

        if (scrollTop < 1) {
            return;
        }

        if (document.getElementById('programming-alerts') !== null) {
            this.headerEl.addClass('goUpWithAlert dark');
        } else {
            this.headerEl.addClass('goUp dark');
        }

        if (!this.isVisibleMainOrHero()) {
            this.heroImage.addClass('fadeOut');
        }
    }

    /**
     * Event handler for scroll up event
     */
    onScrollUpHandler() {
        if (document.getElementById('programming-alerts') !== null) {
            this.headerEl.removeClass('goUpWithAlert');
        } else {
            this.headerEl.removeClass('goUp');
        }

        if (this.isVisibleMainOrHero()) {
            //if not the video page.
            if (!$('.video__player-width-container')[0] || typeof movieStarted !== 'undefined') {
                this.headerEl.removeClass('dark');
                this.heroImage.removeClass('fadeOut');
            }
        }
    }

    isVisibleMainOrHero() {
        let hero = document.querySelector('#hero-content .slide-js h1'),
            main = document.querySelector('#main-container');

        if (hero) {
            return this.isMarqueeCopyVisible(hero);
        } else {
            return this.isMainContainerVisible(main);
        }

        return false;
    }

    isMainContainerVisible(element) {
        if (element.getBoundingClientRect().top >= -112) {
            return true;
        }

        return false;
    }

    /**
     * check if marquee title is in view port
     *
     * @returns {boolean}
     */
    isMarqueeCopyVisible(element) {
        if (element.getBoundingClientRect().top >= 75) {
            return true;
        }

        return false;
    }

    /**
     * check if browser is IE 11 or Edge and load stylesheet
     */
    initStylesForIE() {
        let isIE11 = false,
            isEdge = false;

        try {
            isIE11 = !!navigator.userAgent.match(/Trident\/7\./);

            if (!isIE11) {
                if (navigator.userAgent.indexOf('Edge') > -1) {
                    isEdge = true;
                }
            }
        } catch (e) {}

        if (CBS.Registry.winAssets !== undefined) {
            if (isIE11) {
                document.write(
                    "<link href='" +
                        CBS.Registry.winAssets.ie +
                        "' type='text/css' rel='stylesheet'>"
                );
                $('#programming-alerts-scroll-left-box-text-id')
                    .removeClass('programming-alerts-scroll-left-box-text')
                    .addClass('programming-alerts-scroll-left-box-text-ie');
            }
            if (isEdge) {
                document.write(
                    "<link href='" +
                        CBS.Registry.winAssets.edge +
                        "' type='text/css' rel='stylesheet'>"
                );
                $('#programming-alerts-scroll-left-box-text-id')
                    .removeClass('programming-alerts-scroll-left-box-text')
                    .addClass('programming-alerts-scroll-left-box-text-ie');
            }
        }
    }
}
